module.exports = __webpack_public_path__ + "static/media/Phone.85f54e1b.svg";